import { ComponentsProps, ComponentsOverrides, ComponentsVariants, Theme } from '@mui/material';

export const MuiSnackbar: {
    defaultProps?: ComponentsProps['MuiSnackbar'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiSnackbar'];
    variants?: ComponentsVariants['MuiSnackbar'];
} = {
    defaultProps: { autoHideDuration: 6000 },
    styleOverrides: {
        root: (props) => [
            {
                maxWidth: '440px',
                [props.theme.breakpoints.up('sm')]: {
                    width: '100%',
                },
            },
        ],
    },
};

export const MuiSnackbarContent: {
    defaultProps?: ComponentsProps['MuiSnackbarContent'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiSnackbarContent'];
    variants?: ComponentsVariants['MuiSnackbarContent'];
} = {
    defaultProps: {},
    styleOverrides: {
        message: (props) => [{ ...props.theme.typography.body1, color: 'inherit' }],
        root: (props) => [
            {
                padding: props.theme.spacing(props.theme.tokens.spacing.md),
                width: '100%',
                flexWrap: 'nowrap' as React.CSSProperties['flexWrap'],
                color: props.theme.palette.secondary.contrastText,
                boxShadow: props.theme.shadows[6],
            },
        ],
        action: (props) => [
            {
                marginRight: 'unset',
                paddingLeft: props.theme.spacing(props.theme.tokens.spacing.md),
            },
        ],
    },
};
